/**********************************************************************************************************************/
/* FILE: hafas_webapp.js                                                                                              */
/**********************************************************************************************************************/
// instanciate new Webapp if modules are ready
Hafas.ps.sub('/core/serverTime/done/', function () {
  // The theme is being set as a data attribute
  if(Hafas.Config.Styling.theme){
    document.body.setAttribute('data-theme', Hafas.Config.Styling.theme);
  }

  // Wenn forcedLayoutClass gesetzt ist, darf der body nicht die Höhe 100% erhalten.
  // Daher setzen wir eine Klasse in den Body-Tag um das von hier aus zu überschreiben
  if (Hafas.Config.UI.forceLayoutClass) {
    document.body.setAttribute('data-hafas', Hafas.Config.UI.layoutClass);
  }

  var optionModels = {};
  // Options in Abhängigkeit des Mandanten auswählen
  var optionsPath = Hafas.Config.optionsPath;
  // Werte werden in der Core gesetzt
  if (typeof Hafas.Config.isCustomer != 'undefined' && Hafas.Config.isCustomer === true) {
    optionsPath = 'customer/' + Hafas.Config.CustomerName + '/' + Hafas.Config.optionsPath;
  }


  // set lang-attribute depending on selected Language-Object
  Hafas('html', false).setAttribute('lang', Hafas.Config.currentISO);

  // Prüfe, ob SVGs unterstützt werden (-> wird in Hafas.Config.hasSvgSupport als true/false abgelegt)
  Hafas.Config.hasSvgSupport = Hafas.Util.supportsSvg();

  // Prüfe, ob Passive bei Events als drittes Argument (addEventListener) genutzt werden kann
  Hafas.Config.hasEventPassiveSupport = false;
  try {
    var opts = Object.defineProperty({}, 'passive', {
      get: function() {
        Hafas.Config.hasEventPassiveSupport = true;
      }
    });
    window.addEventListener("testPassive", null, opts);
    window.removeEventListener("testPassive", null, opts);
  } catch (e) {}


  // Base-Template rendern
  if (typeof Hafas.Config.WidgetMode != 'undefined') {
    initAllWidgets();
  } else if (typeof Hafas.Config.webview != 'undefined') {
    startWebview();
  } else {
    if (Hafas.Config.PrivacyPolicy) {
      PrivacyPolicy(renderBaseTemplate);
    } else {
      renderBaseTemplate();
    }
  }

  function renderBaseTemplate() {
    // für right to left Sprachen müssen alles Styles gespiegelt werden.
    if (Hafas.Config.isRTLLanguage) {
      if (Hafas.Modules.RTL != undefined) {
        Hafas.Modules.RTL.flipCss();
        Hafas.Modules.RTL.flipMapController();
      }
      else
        console.warn("RTL Sprache ist aktiv aber das rtl Module wurde nicht geladen!");
    }

    // Druckansicht anzeigen?
    if (document.body.getAttribute('data-hafas-print') == 'printview') {
      startPrintview();
    }
    // Webapp anzeigen
    else {
      // Für welche Features sollen Optionen geladen & angezeigt werden?
      var initOptions = [];
      if (Hafas.Config.Switches.useTravelplanner && Hafas.Config.TP.useQueryOptions) {
        initOptions.push('TP');
      }
      if (Hafas.Config.Switches.useStationboard && Hafas.Config.SQ.useQueryOptions) {
        initOptions.push('SQ');
      }
      if (Hafas.Config.Switches.useHimSearch && Hafas.Config.HimSearch.useQueryOptions) {
        initOptions.push('HimSearch');
      }
      if (Hafas.Config.Switches.useReachability && Hafas.Config.Reachability.useQueryOptions) {
        initOptions.push('Reachability');
      }

      var startCallback = startWebapp;
      if (Hafas.Config.startCallback == 'startWidgetGenerator') {
        startWidgetGenerator();
      } else {
        var model = {
          optionList: initOptions,
          callback: startCallback
        };

        Hafas.Modules.Render.render({
          file: 'common.base.html',
          target: 'HFS_WebApp',
          template: 'Common_WebappBase',
          model: {}
        }, function (html) {
          // Hide PageContent if necessary and layout != small
          // Layout classes in HTML have not been set yet at this point; check config settings and WebApp width
          if (!Hafas.Config.UI.forceLayoutClass || Hafas.Config.UI.layoutClass !== 'small') {
            var webAppW = window.innerWidth;
            var webAppWrap = Hafas('#HFS_WebApp', false);
            if (!Hafas.Config.Switches.useMediaQueries && webAppWrap) {
              webAppW = webAppWrap.offsetWidth;
            }
            if (webAppW > Hafas.Config.UI.layoutClassMinWidths.mid || Hafas.Config.UI.forceLayoutClass) {
              // If PageContent is supposed to be initially hidden, move it all the way out of the visible area now to avoid any confusing animations later.
              // PageContent does not have its final width yet. It will be moved to the correct position (-width) once controllers have been initialized.
              if ((!Hafas.Config.UI.showPageContentOnInit && Hafas.Util.checkWebAppUrlParameter('showPageContent') !== 'true') || Hafas.Util.checkWebAppUrlParameter('showPageContent') === 'false') {
                Hafas('#HFS_PageContent', false).setAttribute("style", "transform: translate(-100vw, 0);");
              }
            }
          }

          initAllOptions(model);
        });
      }

    }
  }

  function initAllWidgets() {
    var widgets = Hafas.Config.Widgets;
    Hafas.Config.WidgetInstances = [];
    new HafasWidgets();
    for (var w = 0; w < widgets.length; w++) {
      var wgt = widgets[w];
      wgt.index = w;
      Hafas.ps.pub('/widgets/init', [wgt]);
    }
  }

  function initAllOptions(params) {
    var optionList = params.optionList;
    var callback = params.callback;
    var optionCount = optionList.length;
    if (optionCount > 0) {
      for (var i = 0; i < optionCount; i++) {
        var application = optionList[i];
        var myOptions = Hafas.Core.newType("hafasRequest", {
          requestType: 'customUrl',
          method: 'get',
          app: application,
          url: optionsPath + 'options_' + application + '.json?v=' + Hafas.Core.getAntiCacheParam(),
          callback: function (data) {
            optionCount--;
            processOptionsQuickFilter(data.application, data.questionList)
            optionModels[data.application] = {questionList: data.questionList};
            if (optionCount == 0) {
              callback({options: optionModels});
            }
          }.bind(this), errorCallback: Hafas.bind(function (data) {
            throw error(data);
          }, this)
        });
      }
    } else {
      callback({options: {}});
    }
  }

  function processOptionsQuickFilter(applicationContext, optionModel) {
    // Check for quick filter set from the server side and use them if available
    if (Hafas.Config.productsQuickFilter && Hafas.Config.productsQuickFilter[applicationContext]) {
      for (var i=0; i < optionModel.length; i++) {
        // Search for products configuration
        var currentOptionModel = optionModel[i];
        if (currentOptionModel.hciType == 'products') {
          var quickFilterServerConfig = getQuickFilterFromServerConfig(applicationContext);
          if (quickFilterServerConfig) {
            currentOptionModel.groupElements = quickFilterServerConfig.groupElements;
            currentOptionModel.productIndex = quickFilterServerConfig.productIndex;
          }
        }
      }
    }
  }

  /**
   * build option quick filter based on the server config (if available)
   * to the default option parameters as defined in json options model
   *
   * @method getQuickFilterFromServerConfig
   * @param {String} applicationContext the respective context for the options to be modified
   *
   * @returns {Object} quickFilterDataModel returns the data model that can be used to overwrite client settings
   * **/
  function getQuickFilterFromServerConfig(applicationContext) {
    let serverQuickFilterConfig = Hafas.Config.productsQuickFilter[applicationContext];

    let quickFilterDataModel = {
      groupElements: [],
      productIndex: 0
    };
    let optionCount = 0;
    // Iterate through optL to build up the quick filter list in webapp client format
    if (serverQuickFilterConfig.optL) {
      for (var i = 0; i < serverQuickFilterConfig.optL.length; i++) {
        let quickFilterOption = serverQuickFilterConfig.optL[i];
        let quickFilterId = "HFS_" + applicationContext + "_QSEL_" + i;
        let groupId = 'HFS_' + applicationContext + 'Products';
        if (applicationContext == 'TP') {
          groupId = 'HFS_productOptions';
        }

        let productQuickFilter = {
          id: quickFilterId,
          labelResolved: quickFilterOption.gui?.txt,
          name: quickFilterId.toLowerCase(),
          type: "button",
          onclick: "Hafas.ps.pub('/options/set/products/quickselection', [{groupId: '" + groupId + "', value: " + quickFilterOption.val + "}]);",
          state: "",
          ctxFilter: {}
        }
        productQuickFilter.ctxFilter[applicationContext] = "ON";
        quickFilterDataModel.groupElements.push(productQuickFilter);
        optionCount++;
      }
    }
    quickFilterDataModel.productIndex = optionCount;
    return quickFilterDataModel;
  }

  function startWebapp(params) {
    new HafasWebapp(params);
  }

  function startWebview() {
    new HafasWebview();
  }

  function PrivacyPolicy(callback) {
    new HafasPolicy(callback);
  }

  function startPrintview() {
    new HafasWebappPrintview();
  }

  function startWidgetGenerator() {
    new HafasWidgetGenerator();
  }
});
